// extracted by mini-css-extract-plugin
module.exports = {"selection":"ActivityLogModal_selection__3NY6A"};